import { useClipboardAvailable } from "@/utils/hooks";
import { ButtonHTMLAttributes, DetailedHTMLProps, useState } from "react";
import { MdLink, MdCheck } from "react-icons/md";
import { toast } from "sonner";

interface Props extends Omit<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  "children" | "onClick"
> {
  to: string;
}

export default function CopyLink({ to, title }: Props) {
  const clipboard = useClipboardAvailable();
  const [copied, setCopied] = useState(false);

  if (!clipboard) {
    return null;
  }

  return (
    <button
      title={title}
      onClick={() => {
        navigator.clipboard.writeText(to);
        setCopied(true);
        toast.success("Copied to clipboard");
      }}
    >
      {copied ? <MdCheck /> : <MdLink />}
    </button>
  );
}
